<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  mounted () {
    console.log('App mounted');
  }
}

</script>

<style lang="scss">
#app {
  position: relative;
  width: 100vw;
  height: 100vh;
  text-align: center;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.question-mention-container {
  width: 5.9rem;
  height: 8.92rem;
  border-radius: 0.2rem;
  background: linear-gradient(180deg, #A4C8FF 0%, #fff 30%, #fff 100%);
  padding: 0.32rem 0.24rem;

  .question-mention-title {
    font-weight: 600;
    font-size: 0.32rem;
    color: #222222;
    line-height: 0.48rem;
    text-align: center;
    font-style: normal;
  }

  ul {
    padding-left: .24rem;
    margin: 0.24rem 0;

    li {
      list-style-type: disc;
      text-align-last: left;
      font-weight: 400;
      font-size: 0.28rem;
      color: #222222;
      line-height: 0.4rem;
      text-align: left;
      font-style: normal;

      .red {
        color: #FF0C0C;
        font-weight: Semibold;
      }
    }
  }

  .question-mention-btn {
    width: 100%;
    font-weight: 600;
    font-size: 0.32rem;
    color: #FFFFFF;
    line-height: 0.4rem;
    text-align: center;
    font-style: normal;
    padding: 0.18rem 0;
    border-radius: 2rem;
    background-color: #6681FA;
    margin: 0.32rem 0;
  }
}
</style>
